import React from "react";

const LoadingIndicator = () => {
  return (
    <div className="font-light text-xl flex items-center justify-center absolute inset-0 z-50 text-center animate-pulse text-bold">
      <span className="dot-bounce text-blue-950 ">.</span>
      <span className="dot-bounce text-blue-950 ">.</span>
      <span className="dot-bounce text-blue-950 ">.</span>
    </div>
  );
};

export default LoadingIndicator;
